(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-home"] && !Shopify.designMode) return;
  try {
    
function focusTcrEnquiryFeedback(root) {
  const feedback = root.querySelector('.tcr-h-form .tcr-h-errors, .tcr-h-form .tcr-h-success');
  if (feedback) feedback.focus();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { focusTcrEnquiryFeedback(document); });
} else {
  focusTcrEnquiryFeedback(document);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-kit-cart"]) return;
  try {
    
if (!customElements.get('tcr-kit-basket')) customElements.define('tcr-kit-basket', class extends HTMLElement {
 connectedCallback() {
  if (this.bound) return;
  this.bound = true;
  this.form = this.querySelector('form');
  this.error = this.querySelector('[data-error-message]');
  this.status = this.querySelector('[data-basket-status]');
  this.savedState = this.currentState();
  this.lockedControls = new Map();
  this.onInput = () => this.showState();
  this.onSubmit = event => {
   event.preventDefault();
   return this.save(event.submitter?.name === 'checkout' ? this.dataset.checkout : this.dataset.cart);
  };
  this.onClick = event => {
   const step = event.target.closest?.('[data-step]');
   if (step && this.contains(step)) {
    if (this.busy) { event.preventDefault(); return; }
    const input = step.parentElement.querySelector('input');
    const value = Number(input.value);
    if (Number.isInteger(value)) input.value = String(Math.min(99, Math.max(0, value + Number(step.dataset.step))));
    this.showState();
    return;
   }
   const link = event.target.closest?.('a[href]');
   if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
   if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
   if (this.busy) { event.preventDefault(); return; }
   if (this.contains(link) && link.hasAttribute('data-remove-key')) {
    event.preventDefault();
    const line = Array.from(this.form.querySelectorAll('[data-cart-line]')).find(item => item.dataset.key === link.dataset.removeKey);
    if (!line) return;
    line.querySelector('input').value = '0';
    this.showState();
    return this.save(this.dataset.cart);
   }
   if (!this.isDirty()) return;
   const target = new URL(link.href, location.href);
   if (!['http:', 'https:'].includes(target.protocol)) return;
   if (target.origin === location.origin && target.pathname === location.pathname && target.search === location.search && target.hash) return;
   event.preventDefault();
   return this.save(target.href);
  };
  this.onBeforeUnload = event => {
   if (this.leaving || (!this.busy && !this.isDirty())) return;
   event.preventDefault();
   event.returnValue = '';
  };
  this.onPageShow = event => {
   if (event.persisted) { this.leaving = true; location.reload(); return; }
   this.leaving = false;
   this.setBusy(false);
  };
  this.form.addEventListener('input', this.onInput);
  this.form.addEventListener('change', this.onInput);
  this.form.addEventListener('submit', this.onSubmit);
  document.addEventListener('click', this.onClick, true);
  window.addEventListener('beforeunload', this.onBeforeUnload);
  window.addEventListener('pageshow', this.onPageShow);
 }
 currentState() {
  return JSON.stringify({ quantities: Array.from(this.form.querySelectorAll('[data-cart-line]'), line => [line.dataset.key, line.querySelector('input').value]), note: this.form.querySelector('[name=note]').value, acceptance: Array.from(this.form.querySelectorAll('[data-order-acceptance]'), field => [field.dataset.attribute, field.checked]) });
 }
 isDirty() { return this.currentState() !== this.savedState; }
 showState() {
  this.status.textContent = this.busy ? this.dataset.updating : this.isDirty() ? this.dataset.pending : '';
  this.status.hidden = !this.status.textContent;
 }
 setBusy(busy) {
  this.busy = busy;
  if (busy) {
   this.form.setAttribute('aria-busy', 'true');
   this.form.querySelectorAll('button, input, textarea, select').forEach(control => {
    this.lockedControls.set(control, control.disabled);
    control.disabled = true;
   });
   this.form.querySelectorAll('a').forEach(link => link.setAttribute('aria-disabled', 'true'));
  } else {
   this.form.removeAttribute('aria-busy');
   this.lockedControls.forEach((disabled, control) => { control.disabled = disabled; });
   this.lockedControls.clear();
   this.form.querySelectorAll('a').forEach(link => link.removeAttribute('aria-disabled'));
  }
  this.showState();
 }
 async save(destination) {
  if (this.busy) return;
  if (destination === this.dataset.checkout && !this.form.reportValidity()) return;
  if (!Array.from(this.form.querySelectorAll('[name="updates[]"]')).every(input => input.reportValidity())) return;
  const updates = {};
  this.form.querySelectorAll('[data-cart-line]').forEach(line => { updates[line.dataset.key] = Number(line.querySelector('input').value); });
  const attributes = {};
  this.form.querySelectorAll('[data-order-acceptance]').forEach(field => { attributes[field.dataset.attribute] = field.checked ? field.value : ''; });
  const payload = { updates, note: this.form.querySelector('[name=note]').value, attributes };
  this.error.hidden = true;
  this.setBusy(true);
  let message = this.dataset.error;
  try {
   const response = await fetch(this.dataset.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(20000) });
   const result = await response.json();
   if (!response.ok) {
    if (typeof result?.description === 'string') message = result.description;
    throw new Error();
   }
   if (!Number.isInteger(result?.item_count) || result.item_count < 0) throw new Error();
   this.savedState = this.currentState();
   this.leaving = true;
   location.assign(destination === this.dataset.checkout && result.item_count === 0 ? this.dataset.cart : destination);
  } catch {
   this.leaving = false;
   this.error.textContent = message;
   this.error.hidden = false;
   this.error.scrollIntoView({ block: 'center' });
   this.setBusy(false);
  }
 }
 disconnectedCallback() {
  this.form?.removeEventListener('input', this.onInput);
  this.form?.removeEventListener('change', this.onInput);
  this.form?.removeEventListener('submit', this.onSubmit);
  document.removeEventListener('click', this.onClick, true);
  window.removeEventListener('beforeunload', this.onBeforeUnload);
  window.removeEventListener('pageshow', this.onPageShow);
  this.bound = false;
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-kit-product"]) return;
  try {
    
if (!customElements.get('tcr-kit-purchase')) customElements.define('tcr-kit-purchase', class extends HTMLElement {
 connectedCallback() {
  if(this.bound)return; this.bound=true;
  const form=this.querySelector('form'), button=form.querySelector('button[type="submit"]'), error=this.querySelector('[data-error-message]');
  const originalLabel=button.innerHTML;window.addEventListener('pageshow',()=>{this.busy=false;button.disabled=!form.querySelector('input[name=id]:checked:not(:disabled)');button.innerHTML=originalLabel;});
  form.addEventListener('change',event=>{if(event.target.name==='id'){this.querySelector('[data-price-display]').textContent=event.target.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState(null,'',url);}});
  form.addEventListener('submit',async event=>{
   event.preventDefault();if(this.busy||!form.reportValidity())return;
   this.busy=true;const label=button.innerHTML;button.disabled=true;button.textContent=this.dataset.adding;error.hidden=true;
   try {
    const response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:AbortSignal.timeout(20000)});
    const result=await response.json().catch(()=>{throw new Error(this.dataset.error)});if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
    location.assign(this.dataset.cart);
   } catch(err){error.textContent=(err.name==='TypeError'||err.name==='TimeoutError'||err.name==='AbortError')?this.dataset.error:err.message||this.dataset.error;error.hidden=false;button.disabled=false;button.innerHTML=label;this.busy=false;}
  });
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-navigation"]) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.tcr-nav__mobile a');if(link){const menu=link.closest('details');if(menu)menu.open=false;}});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.tcr-nav__mobile[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-p-contact"]) return;
  try {
    
(() => {
  const mounts = document.querySelectorAll('[data-tcr-hubspot]');
  mounts.forEach(mount => {
    if (mount.dataset.initialized === 'true') return;
    mount.dataset.initialized = 'true';
    const frame = mount.querySelector('.hs-form-frame');
    const status = mount.querySelector('[data-hubspot-status]');
    const config = mount.dataset;
    const uuidPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
    const expectedScripts = {
      na1: 'https://js.hsforms.net/forms/embed/149121893.js',
      eu1: 'https://js-eu1.hsforms.net/forms/embed/149121893.js'
    };
    const setStatus = (message, alert = false) => {
      status.textContent = message;
      status.setAttribute('role', alert ? 'alert' : 'status');
      status.hidden = !message;
      mount.removeAttribute('aria-busy');
    };
    // Invalid or absent configuration must not collect data through Shopify.
    if (!uuidPattern.test(config.formId || '') ||
        !expectedScripts[config.region] || config.embedUrl !== expectedScripts[config.region] ||
        config.preview === 'true') {
      setStatus(config.unavailableMessage);
      return;
    }
    const storageKey = 'tcr-hubspot-submission-v1:' + config.formId;
    let submissionId;
    let instanceId;
    let liveForm;
    let interest = '';
    const interestStatus = mount.closest('section').querySelector('[data-tcr-interest-status]');
    const syncInterest = () => {
      if (!liveForm) return;
      try { liveForm.setExtraSubmissionMetadata({ tcr_submission_id: submissionId, tcr_interest: interest || 'general' }); } catch {}
    };
    document.addEventListener('click', event => {
      const choice = event.target.closest('[data-tcr-interest]');
      if (!choice || !['solar', 'storage'].includes(choice.dataset.tcrInterest)) return;
      interest = choice.dataset.tcrInterest;
      if (interestStatus) {
        interestStatus.textContent = interestStatus.dataset[interest];
        interestStatus.hidden = false;
      }
      syncInterest();
    });
    let ready = false;
    let submitted = false;
    let initializing = false;
    let timer;
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (saved && uuidPattern.test(saved.id) && Date.now() >= saved.time && Date.now() - saved.time < 86400000) {
        submissionId = saved.id;
      }
    } catch {}
    try {
      submissionId ||= crypto.randomUUID();
    } catch {
      setStatus(config.unavailableMessage, true);
      return;
    }
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ id: submissionId, time: Date.now() }));
    } catch {}
    const matches = event => event.detail?.formId === config.formId &&
      (!instanceId || event.detail.instanceId === instanceId);
    const failLoading = () => {
      if (!ready && !submitted) setStatus(config.loadErrorMessage, true);
    };
    // Register before appending HubSpot's script so a cached load cannot win the race.
    window.addEventListener('hs-form-event:on-ready', async event => {
      if (!matches(event) || ready || submitted || initializing) return;
      initializing = true;
      instanceId = event.detail.instanceId;
      try {
        const form = window.HubSpotFormsV4.getFormFromEvent(event);
        const fields = await form.getFormFieldValues();
        if (fields.some(field => field.name === '0-1/tcr_submission_id')) {
          await form.setFieldValue('0-1/tcr_submission_id', [submissionId]);
          const assigned = await form.getFieldValue('0-1/tcr_submission_id');
          if ((Array.isArray(assigned) ? assigned[0] : assigned) !== submissionId) throw Error('Unconfirmed submission reference');
        } else {
          form.setExtraSubmissionMetadata({ tcr_submission_id: submissionId });
        }
        liveForm = form;
        syncInterest();
        ready = true;
        clearTimeout(timer);
        frame.inert = false;
        frame.classList.remove('tcr-hubspot-pending');
        frame.removeAttribute('aria-hidden');
        setStatus('');
      } catch {
        failLoading();
      } finally {
        initializing = false;
      }
    });
    window.addEventListener('hs-form-event:on-submission:failed', event => {
      if (!ready || submitted || !matches(event)) return;
      setStatus(config.errorMessage, true);
      // Keep HubSpot's form, values and reference intact for the customer's retry.
    });
    window.addEventListener('hs-form-event:on-submission:success', event => {
      if (!ready || submitted || !matches(event)) return;
      submitted = true;
      clearTimeout(timer);
      frame.hidden = true;
      frame.inert = true;
      setStatus(config.successMessage);
      status.focus();
      try { sessionStorage.removeItem(storageKey); } catch {}
    });
    mount.setAttribute('aria-busy', 'true');
    setStatus(config.loadingMessage);
    mount.setAttribute('aria-busy', 'true');
    timer = setTimeout(failLoading, 15000);
    const script = document.createElement('script');
    script.src = config.embedUrl;
    script.async = false;
    script.defer = true;
    script.addEventListener('error', failLoading, { once: true });
    document.head.append(script);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-p-finder"]) return;
  try {
    

(()=>{
const emit=(event,properties={})=>document.dispatchEvent(new CustomEvent('tcr:analytics',{detail:{event,...properties}}));
const init=()=>{
 const finder=document.querySelector('[data-tcr-finder]');
 if(!finder||finder.dataset.ready)return;
 finder.dataset.ready='true';finder.querySelector('[data-finder-ui]').hidden=false;
 const route=finder.querySelector('[data-finder-route]'),existing=finder.querySelector('[data-finder-existing]'),support=finder.querySelector('[data-finder-support]');
 const result=finder.querySelector('[data-finder-result]'),error=finder.querySelector('[data-finder-error]');let started=false;
 const begin=()=>{if(!started){emit('tcr_finder_started',{placement:'homepage'});started=true}};
 [route,existing,support].forEach(el=>el.addEventListener('change',()=>{begin();result.hidden=true;error.hidden=true}));
 const transfer=()=>{
  const interest=document.querySelector('[data-contact-interest]'),context=document.querySelector('[data-contact-context]');
  if(interest&&support.value)interest.value=support.value;
  if(context)context.value=[route,existing,support].map(el=>el.value?el.options[el.selectedIndex].text:'').filter(Boolean).join(' / ');
 };
 document.querySelectorAll('[data-tcr-support]').forEach(link=>link.addEventListener('click',()=>{support.value=link.dataset.tcrSupport;result.hidden=true;error.hidden=true;transfer();emit('tcr_support_selected',{support:support.value,placement:'support_choices'})}));
 finder.querySelector('[data-finder-submit]').addEventListener('click',()=>{
  begin();const missing=[route,existing,support].find(el=>!el.value);
  if(missing){error.hidden=false;missing.focus();return}
  error.hidden=true;const key=existing.value==='yes'?'retrofit':route.value;
  const template=finder.querySelector('[data-finder-template="'+key+'"]');
  const answer=finder.querySelector('[data-finder-answer]');answer.replaceChildren(template.content.cloneNode(true));
  finder.querySelectorAll('[data-support]').forEach(el=>el.hidden=el.dataset.support!==support.value);
  result.hidden=false;transfer();result.focus({preventScroll:true});
  emit('tcr_finder_completed',{route:route.value,existing_solar:existing.value,support:support.value});
 });
 finder.querySelector('[data-finder-enquire]').addEventListener('click',transfer);
 document.querySelectorAll('[data-tcr-interest]').forEach(link=>link.addEventListener('click',()=>{const interest=document.querySelector('[data-contact-interest]');if(interest)interest.value=link.dataset.tcrInterest;emit('tcr_upgrade_interest',{stage:link.dataset.tcrInterest,placement:'storage_story'})}));
 const form=document.querySelector('[data-tcr-contact]');
 if(form){let began=false;form.addEventListener('input',()=>{if(!began){began=true;emit('tcr_enquiry_started',{route:document.querySelector('[data-contact-interest]')?.value||'unsure'})}});if(form.querySelector('[data-form-success]'))emit('tcr_enquiry_submitted',{form:'premium_home'})}
 document.querySelectorAll('[data-contact-channel]').forEach(link=>link.addEventListener('click',()=>emit('tcr_contact_clicked',{channel:link.dataset.contactChannel,placement:'homepage'})));
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-p-header"]) return;
  try {
    
document.querySelectorAll('.tcr-mobile-nav').forEach(menu=>{menu.addEventListener('click',e=>{if(e.target.closest('a'))menu.open=false});menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tcr-product-story')){
 customElements.define('tcr-product-story',class extends HTMLElement{
  connectedCallback(){
   this.track=this.querySelector('.tcr-product-track');
   this.stage=this.querySelector('.tcr-product-stage');
   this.object=this.querySelector('.tcr-product-object');
   this.copies=Array.from(this.querySelectorAll('[data-scene]'));
   this.links=Array.from(this.querySelectorAll('[data-chapter]'));
   this.garden=this.querySelector('.tcr-product-space');
   this.gardenPhoto=this.querySelector('.tcr-space-photo');
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.frame=0;this.active=-1;
   this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.render()})};
   this.configure=()=>{
    let enabled=this.dataset.motion==='true'&&!this.reduced.matches&&innerHeight>=(innerWidth<=760?730:620)&&innerWidth>=360;
    this.classList.toggle('is-motion',enabled);
    if(enabled&&innerWidth<=760){
     const copyEnd=Math.max(...this.copies.map(el=>el.getBoundingClientRect().height))+36;
     const space=innerHeight-copyEnd-130;
     if(space<220){enabled=false;this.classList.remove('is-motion')}
     else{
      this.style.setProperty('--mobile-product-width',`${space*1.5}px`);
      this.style.setProperty('--mobile-product-center',`${copyEnd+20+space/2}px`);
      this.style.setProperty('--mobile-detail-top',`${copyEnd+20}px`);
      this.style.setProperty('--mobile-detail-height',`${space}px`);
     }
    }
    this.enabled=enabled;
    this.scroller=window;
    let parent=this.parentElement;
    while(parent&&parent!==document.body){
     if(/auto|scroll/.test(getComputedStyle(parent).overflowY)&&parent.scrollHeight>parent.clientHeight+1){this.scroller=parent;break}
     parent=parent.parentElement;
    }
    this.copies.forEach(el=>{el.inert=false;el.removeAttribute('aria-hidden');el.removeAttribute('data-active');el.style.removeProperty('--copy-opacity');el.style.removeProperty('--copy-y')});
    this.active=-1;
    this.links.forEach(el=>el.removeAttribute('aria-current'));
    if(!enabled){this.object.removeAttribute('style');this.stage.removeAttribute('style');if(this.gardenPhoto)this.gardenPhoto.removeAttribute('style')}
    this.schedule();
   };
   this.onChapter=e=>{
    const link=e.target.closest('[data-chapter]');
    if(!link||!this.enabled)return;
    e.preventDefault();
    const scroller=this.scroller||window;
    const base=scroller===window?0:scroller.getBoundingClientRect().top;
    const scrollPosition=scroller===window?scrollY:scroller.scrollTop;
    const i=Number(link.dataset.chapter),top=this.track.getBoundingClientRect().top-base+scrollPosition;
    const distance=this.track.offsetHeight-this.stage.offsetHeight;
    const target=[0,.41,.82][i];
    scroller.scrollTo({top:top+distance*target,behavior:'auto'});
    history.replaceState(null,'',link.getAttribute('href'));
    this.render();
   };
   this.querySelector('.tcr-product-progress').addEventListener('click',this.onChapter);
   addEventListener('scroll',this.schedule,{passive:true,capture:true});
   addEventListener('resize',this.configure,{passive:true});
   this.reduced.addEventListener('change',this.configure);
   this.configure();
  }
  render(){
   if(!this.enabled)return;
   const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v));
   const smooth=v=>{v=clamp(v);return v*v*(3-2*v)};
   const box=this.track.getBoundingClientRect(),distance=Math.max(1,this.track.offsetHeight-this.stage.offsetHeight);
   const scrollOrigin=this.scroller===window?0:this.scroller.getBoundingClientRect().top;
   const p=clamp((scrollOrigin-box.top)/distance),first=smooth((p-.23)/.12),second=smooth((p-.59)/.12);
   const i=p<.29?0:p<.65?1:2;
   const opacity=[clamp((.29-p)/.035),Math.min(clamp((p-.29)/.035),clamp((.65-p)/.035)),clamp((p-.65)/.035)];
   this.copies.forEach((el,index)=>{
    el.style.setProperty('--copy-opacity',opacity[index].toFixed(3));
    el.style.setProperty('--copy-y',`${(1-opacity[index])*25}px`);
    el.dataset.active=opacity[index]>.001?'true':'false';
    el.inert=index!==i;
    el.setAttribute('aria-hidden',index!==i?'true':'false');
   });
   if(this.active!==i){this.active=i;this.links.forEach((link,index)=>{if(index===i)link.setAttribute('aria-current','step');else link.removeAttribute('aria-current')});this.dataset.activeScene=String(i)}
   const mobile=innerWidth<=760;
   this.object.style.setProperty('--kit-x',`${mobile?(-first*3+second*4):(-first*9+second*2)}%`);
   this.object.style.setProperty('--kit-y',`${mobile?first*18-second*15:first*25-second*18}px`);
   this.object.style.setProperty('--kit-scale',(mobile?1+first*.08-second*.05:1+first*.22+second*.05).toFixed(3));
   this.object.style.setProperty('--object-opacity',(1-second*.92).toFixed(3));
   this.stage.style.setProperty('--detail-opacity',second.toFixed(3));
   this.stage.style.setProperty('--detail-y',`${(1-second)*30}px`);
   this.stage.style.setProperty('--tag-opacity',first.toFixed(3));
   const tag=this.querySelector('[data-product-label]');
   if(tag&&this.links[i])tag.textContent=this.links[i].textContent.replace(/^\s*0\d\s*/,'').trim();
   const g=this.garden.getBoundingClientRect();
   const gp=clamp((innerHeight-g.top)/(innerHeight+g.height));
   if(this.gardenPhoto){this.gardenPhoto.style.setProperty('--space-scale',(1.15-gp*.15).toFixed(3));this.gardenPhoto.style.setProperty('--space-y',`${(gp-.5)*50}px`)}
  }
  disconnectedCallback(){
   removeEventListener('scroll',this.schedule,true);removeEventListener('resize',this.configure);
   this.reduced?.removeEventListener('change',this.configure);
   this.querySelector('.tcr-product-progress')?.removeEventListener('click',this.onChapter);
   if(this.frame)cancelAnimationFrame(this.frame);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-reveal-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tcr-reveal-story')) {
  customElements.define('tcr-reveal-story', class extends HTMLElement {
    connectedCallback() {
      this.hero = this.querySelector('.tcr-reveal-hero');
      this.photo = this.querySelector('.tcr-reveal-motion-photo');
      this.motionQuery = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      this.frame = null;
      this.queueUpdate = () => {
        if (this.frame !== null) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          if (!this.photo || !this.hero) return;
          if (this.dataset.motion !== 'true' || !this.motionQuery.matches) {
            this.photo.style.removeProperty('--tcr-reveal-shift');
            return;
          }
          const bounds = this.hero.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          if (bounds.bottom < 0 || bounds.top > viewportHeight) return;
          const progress = (viewportHeight / 2 - bounds.top - bounds.height / 2) / viewportHeight;
          const shift = Math.max(-24, Math.min(24, progress * 48));
          this.photo.style.setProperty('--tcr-reveal-shift', `${shift.toFixed(2)}px`);
        });
      };
      window.addEventListener('scroll', this.queueUpdate, { passive: true, capture: true });
      window.addEventListener('resize', this.queueUpdate, { passive: true });
      this.motionQuery.addEventListener('change', this.queueUpdate);
      this.queueUpdate();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.queueUpdate, true);
      window.removeEventListener('resize', this.queueUpdate);
      this.motionQuery?.removeEventListener('change', this.queueUpdate);
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-xds-product"]) return;
  try {
    
if (!customElements.get('tcr-kit-purchase')) customElements.define('tcr-kit-purchase', class extends HTMLElement {
 connectedCallback() {
  if(this.bound)return; this.bound=true;
  const form=this.querySelector('form'), button=form.querySelector('button[type="submit"]'), error=this.querySelector('[data-error-message]');
  const originalLabel=button.innerHTML;
  const syncButton=()=>{button.disabled=this.busy||!form.querySelector('input[name=id]:checked:not(:disabled)');};
  this.busy=false; syncButton();
  window.addEventListener('pageshow',()=>{this.busy=false;button.innerHTML=originalLabel;syncButton();});
  form.addEventListener('change',event=>{if(event.target.name==='id'){this.querySelector('[data-price-display]').textContent=event.target.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState(null,'',url);syncButton();}});
  form.addEventListener('submit',async event=>{event.preventDefault();if(this.busy||!form.reportValidity())return;this.busy=true;const label=button.innerHTML;button.disabled=true;button.textContent=this.dataset.adding;error.hidden=true;try{const response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:AbortSignal.timeout(20000)});const result=await response.json().catch(()=>{throw new Error(this.dataset.error)});if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);location.assign(this.dataset.cart);}catch(err){error.textContent=(err.name==='TypeError'||err.name==='TimeoutError'||err.name==='AbortError')?this.dataset.error:err.message||this.dataset.error;error.hidden=false;this.busy=false;button.innerHTML=label;syncButton();}});
 }
});

  } catch(e) { console.error(e); }
})();
})();
